import { HTTP_HEADERS } from 'aven_types'

const SENSITIVE_HEADER_NAMES = [
    'Authorization',
    'SessionAuthorization',
    'CoApplicantAuthorization',
    'NotaryAuthorization',
    'SupportVideoAuthorization',
    HTTP_HEADERS.HIL_MERCHANT_APPLICATION_RESUME_TOKEN,
    'Cookie',
    'Set-Cookie',
]

// OpenReplay matches ignoreHeaders case-sensitively, so every casing our apps send has to be listed
export const OPENREPLAY_IGNORED_NETWORK_HEADERS: string[] = [...new Set(SENSITIVE_HEADER_NAMES.flatMap((headerName) => [headerName, headerName.toLowerCase()]))]

const SENSITIVE_HEADER_NAME_PATTERN = /authorization|token|cookie/i

interface OpenReplayNetworkCaptureHeaders {
    headers: Record<string, string>
}

interface OpenReplayNetworkCapture {
    request: OpenReplayNetworkCaptureHeaders
    response: OpenReplayNetworkCaptureHeaders
}

const omitSensitiveHeaders = (headers: Record<string, string>): Record<string, string> =>
    Object.fromEntries(Object.entries(headers).filter(([headerName]) => !SENSITIVE_HEADER_NAME_PATTERN.test(headerName)))

export const stripSensitiveHeadersFromOpenReplayNetworkCapture = <Capture extends OpenReplayNetworkCapture>(capture: Capture): Capture => ({
    ...capture,
    request: { ...capture.request, headers: omitSensitiveHeaders(capture.request.headers) },
    response: { ...capture.response, headers: omitSensitiveHeaders(capture.response.headers) },
})
